import { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import './declarationDetails.scss'
import { FormBuilder } from '@airtel/team-form-builder';
import PropTypes from 'prop-types';
import { connect } from "react-redux";
import { notificationSuccess } from "../../../redux/actions/actions";
import { fetchForm, saveForm, updateTask, uploadFileService } from '../../../api/UserDataAPI';
import { getFromSessionStorage, getUserLoggedInDetails, isManualCinEntry, processFormDataToDisablePrefilledFields } from '../../common/Utility/Utility';
import { PATHS } from '../../../constants/paths';

const Declaration = ({ notificationSuccess, }) => {
    const [formData, setFormData] = useState({});
    const navigate = useNavigate();
    const loggedInUser = getUserLoggedInDetails();
    const selectedPartnership = JSON.parse(getFromSessionStorage('selectedPartnership')) || {};

    const showMessage = (message) => {
        const { text } = message;
        notificationSuccess(text);
    }

    const onSave = async (data) => {
        // Refetch latest form metadata to ensure manualCin is computed against fresh values
        let freshFormData = await fetchForm({ userId: loggedInUser?.userUuid });
        freshFormData = processFormDataToDisablePrefilledFields(freshFormData) // Process fresh form data to get the latest state of prefilled fields
        // Check if CIN (declare16) is being manually filled by user (use fresh metadata)
        const manualCin = freshFormData?.manualCin || isManualCinEntry(freshFormData, data);

        // Add manualCin flag to the payload
        const payloadData = {
            userId: loggedInUser.userUuid,
            form: {
                declaration: data.form
            },
            manualCin
        };

        await saveForm(payloadData);
        await updateTask({
            "taskId": "DECLARATION",
            "status": "COMPLETED"
        }, {
            "partnership-id": selectedPartnership?.id
        })
        notificationSuccess("Details saved successfully!");
        navigate(PATHS.dashboard + `?id=${selectedPartnership?.id}`);
    }

    const uploadFile = async (headers, bodyParams) => {
        const response = await uploadFileService(bodyParams, headers);
        notificationSuccess("File uploaded successfully!");
        return response?.result;
    }

    const getFormData = async () => {
        try {
            let resp = await fetchForm({ userId: loggedInUser?.userUuid });
            if (resp) {
                const processedFormData = processFormDataToDisablePrefilledFields(resp)
                setFormData(processedFormData);

            }
        } catch (e) {
            // props.getInitialValues(getDisplayMessage(e), "red");
            console.log(e);
        }

    }
    useEffect(() => {
        getFormData();
    }, [])


    return (
        <div>
            {formData?.form && (
                <FormBuilder
                    metaData={formData}
                    onSave={onSave}
                    formInputApiCall={() => { }}
                    uploadFile={uploadFile}
                    onSubmit={() => { }}
                    showMessage={showMessage}
                    showTab={false}
                />
            )}
        </div>
    )
}

Declaration.propTypes = {
    companyProfileState: PropTypes.object,
    notificationSuccess: PropTypes.func
}
const mapStateToProps = (state) => ({
    companyProfileState: state.companyProfileState
});
const mapDispatchToProps = (dispatch) => ({
    notificationSuccess: (msg) => dispatch(notificationSuccess(msg)),
});


export default connect(mapStateToProps, mapDispatchToProps)(Declaration);